import { Box, Text } from 'grommet';
import { Article, Dashboard, Group, VirtualMachine } from 'grommet-icons';
import React from 'react';
import { AssetAdminTab, tabToLabel } from '../types';

const tabToIcon = {
  [AssetAdminTab.HOME]: Dashboard,
  [AssetAdminTab.NEWS]: Article,
  [AssetAdminTab.COURSE]: Group,
  [AssetAdminTab.PAGES]: VirtualMachine,
};

interface AssetNavigatorProps {
  handleClick: (tab: AssetAdminTab) => void;
  activeTab: AssetAdminTab;
}

const tabs = [AssetAdminTab.PAGES, AssetAdminTab.NEWS, AssetAdminTab.COURSE]

const AssetNavigator = ({ handleClick, activeTab }: AssetNavigatorProps) => (
  <Box pad="small">
    {tabs
      .map((tab) => ({ Icon: tabToIcon[tab], tab }))
      .map(({ tab, Icon }, i) => (
        <Box
          key={i}
          pad="small"
          onClick={() => handleClick(tab)}
          hoverIndicator
          direction="row"
          align="center"
        >
          <Icon size="medium" />
          <Text
            weight={activeTab === tab ? 'bold' : 'normal'}
            style={{ paddingLeft: '12px' }}
          >
            {tabToLabel[tab]}
          </Text>
        </Box>
      ))}
  </Box>
);
export default AssetNavigator;
